import { Client, IMessage } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { useCallback } from "react";
import { useCurrentUser } from "../api-hooks/use-current-user";
import { Message } from "../api/message-request";

export const useLoadChatSocket = () => {
  const { user } = useCurrentUser();
  const loadChatSocket = useCallback(
    (callback: (message: Message) => void) => {
      const socket = new SockJS(
        `${process.env.REACT_APP_API_URL}/chat?user-id=${user?.id}`,
      );
      const client = new Client({
        webSocketFactory: () => socket,
        reconnectDelay: 5000,
        onConnect: () => {
          client.subscribe(`/user/queue/messages`, (msg: IMessage) => {
            callback(JSON.parse(msg.body));
          });
        },
        onStompError: (frame) => {
          console.error("STOMP error: ", frame);
        },
      });

      return client;
    },
    [user?.id],
  );

  return { loadChatSocket };
};
